import type { Ref } from 'react';
import { forwardRef } from 'react';
import type { SelectProps } from '@heroui/react';
import { Select as HeroUISelect } from '@heroui/react';

import { useField } from './useField';

export const Select = forwardRef((props: SelectProps, ref: Ref<HTMLSelectElement>) => {
  const { classNames, popoverProps, ...rest } = props;
  const commonsProps = useField({}, classNames);

  // HeroUI's popover content renders with role="dialog" (react-aria's
  // useDialog) but is never given an accessible name of its own, so axe
  // flags every open Select as an aria-dialog-name violation. Forward the
  // trigger's own name down to the popover's dialog container.
  const dialogAriaLabel =
    rest['aria-label'] ?? (typeof rest.label === 'string' ? rest.label : undefined);

  return (
    <HeroUISelect
      ref={ref}
      {...commonsProps}
      showScrollIndicators
      labelPlacement="outside-top"
      {...rest}
      popoverProps={{
        ...popoverProps,
        dialogProps: { 'aria-label': dialogAriaLabel, ...popoverProps?.dialogProps },
      }}
    />
  );
});

Select.displayName = 'Select';

export { SelectItem } from '@heroui/react';
